import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorToast } from "@/shared/ui";
import { applyCancellationDiscount, billingQueriesStore } from "../api";

export const useApplyCancellationDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applyCancellationDiscount,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: billingQueriesStore.subscriptions.queryKey,
      });
    },
    onError: errorToast,
  });
};
